__turbopack_context__.v({
  "buttonLink": "StartMetabolic-module__IIFgRG__buttonLink",
  "container": "StartMetabolic-module__IIFgRG__container",
  "content": "StartMetabolic-module__IIFgRG__content",
  "img": "StartMetabolic-module__IIFgRG__img",
  "title": "StartMetabolic-module__IIFgRG__title",
});
